import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { AppDispatch } from "../../redux/store";
import Header from "../../components/common/Header/Header";
import { fetchNotifications } from "../../redux/actions/notifications.actions";
import NotificationsContainer from "./components/NotificationsContainer";
import CreateNotificationModal from "./components/CreateNotificationModal";
import UpdateNotificationModal from "./components/UpdateNotificationModal";
import DeleteNotificationModal from "./components/DeleteNotificationModal";
import NotificationDetailsModal from "./components/NotificationDetailsModal";

const NotificationsPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const searchParams = useSearchParams()[0];

  const [createOpen, setCreateOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const [notifToModify, setNotifToModify] = useState(null);

  useEffect(() => {
    dispatch(fetchNotifications(searchParams.toString()));
  }, [dispatch, searchParams]);

  return (
    <div className="page lp-page">
      <CreateNotificationModal open={createOpen} setOpen={setCreateOpen} />
      <UpdateNotificationModal open={editOpen} setOpen={setEditOpen} object={notifToModify} />
      <DeleteNotificationModal open={deleteOpen} setOpen={setDeleteOpen} object={notifToModify} />
      <NotificationDetailsModal open={viewOpen} setOpen={setViewOpen} object={notifToModify} />

      <Header header="Notifications" />
      <main className="lp-main">
        <NotificationsContainer
          setCreateOpen={setCreateOpen}
          setEditOpen={setEditOpen}
          setDeleteOpen={setDeleteOpen}
          setViewOpen={setViewOpen}
          setNotifToModify={setNotifToModify}
        />
      </main>
    </div>
  );
};

export default NotificationsPage;
